// extracted by mini-css-extract-plugin
export default {"outerDiv":"UserPhotosCard_outerDiv__j2dQD","innerDiv":"UserPhotosCard_innerDiv__bzgVs"};